import { SURF_APP_ID } from "../constants.js";
import { SurfCloudAPI } from "../graphql/surfApi.js";
const RUNNING = new Set(["PENDING", "QUEUED", "RUNNING", "PROCESSING"]);
const FAILED = new Set(["FAILED", "CANCELLED", "EXPIRED"]);
export function classifyJobActivityStatus(status) {
    const upper = status.toUpperCase();
    if (FAILED.has(upper))
        return "failed";
    if (RUNNING.has(upper))
        return "running";
    return "done";
}
export function parseClientLogLines(json) {
    if (!json?.trim())
        return [];
    try {
        const parsed = JSON.parse(json);
        if (!Array.isArray(parsed))
            return [];
        return parsed.map((line) => String(line)).filter(Boolean);
    }
    catch {
        return [];
    }
}
/** Keep the newest row per jobId (input assumed newest-first). */
export function dedupeActivityJobs(jobs) {
    const seen = new Set();
    const out = [];
    for (const job of jobs) {
        if (seen.has(job.jobId))
            continue;
        seen.add(job.jobId);
        out.push(job);
    }
    return out;
}
export function formatSurfFeatureLabel(feature) {
    if (!feature?.trim())
        return "AI";
    return feature
        .replace(/^surf\./, "")
        .replace(/\./g, " · ")
        .replace(/-/g, " ");
}
function mapActivityJob(raw) {
    return {
        jobId: raw.jobId,
        appId: raw.appId ?? SURF_APP_ID,
        kind: raw.kind ?? "UNKNOWN",
        status: raw.status,
        feature: raw.feature,
        prompt: raw.prompt,
        progress: raw.progress,
        errorMessage: raw.errorMessage,
        errorCode: raw.errorCode,
        clientLogLines: parseClientLogLines(raw.clientLogLinesJson),
        costCents: raw.costCents,
        createdAt: raw.createdAt ?? "",
        updatedAt: raw.updatedAt ?? "",
        completedAt: raw.completedAt,
    };
}
export async function listSurfActivityJobs(cfg, options) {
    const limit = options?.limit ?? 20;
    const result = await SurfCloudAPI.listAIJobs(cfg, {
        appId: SURF_APP_ID,
        limit,
        nextToken: options?.nextToken,
    });
    return {
        items: dedupeActivityJobs(result.items.map(mapActivityJob)),
        nextToken: result.nextToken,
    };
}
